import { css } from '@emotion/react';

import { typography } from '@core/Typography2';
import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('inputAdornment', [
  'root',
  'top',
  'center',
  'hiddenLabel',
  'filled',
  'standard',
  'valid',
  'invalid',
  'hasSeparator',
  'start',
  'end',
]);

const getInputAdornmentCss = css`
  margin: 0;
  height: unset;
  max-height: unset;
  align-self: stretch;
  padding: 0 var(--cds-spacing-200);
  color: var(--cds-color-neutral-primary);
  border-radius: 0;

  ${typography.bodySecondary}

  &.${classes.filled}:not(.${classes.hiddenLabel}) {
    margin: 0;
  }

  &.${classes.top} {
    top: 0;
    position: absolute;
    right: 0;
    align-items: flex-start;
    padding-top: var(--cds-spacing-150);
  }

  &.${classes.center} {
    align-items: center;
  }

  &.${classes.filled} {
    background: var(--cds-color-neutral-background-primary-weak);
  }

  &.${classes.standard} {
    background: unset;
  }

  &.${classes.valid} {
    color: var(--cds-color-feedback-success);
    padding-left: var(--cds-spacing-150);
    padding-right: var(--cds-spacing-150);
  }

  &.${classes.invalid} {
    color: var(--cds-color-feedback-error);
    padding-left: var(--cds-spacing-150);
    padding-right: var(--cds-spacing-150);
  }

  &.${classes.hasSeparator} {
    &.${classes.start} {
      border-inline-end: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    }

    &.${classes.end} {
      border-inline-start: 1px solid
        var(--cds-color-neutral-stroke-primary-weak);
    }
  }
`;

export default getInputAdornmentCss;
